export function Doge(props: React.SVGAttributes<{}>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2878 7.9082H10.5732V11.2885H13.2707V12.7038H10.5732V16.0838H12.3718C12.8339 16.0838 16.1657 16.136 16.1606 12.1512C16.1554 8.16632 12.9291 7.9082 12.2878 7.9082Z"
        fill="#C2A633"
      />
      <path
        d="M12 0C5.37252 0 0 5.37252 0 12C0 18.6275 5.37252 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37252 18.6275 0 12 0ZM12.4715 18.4812H8.12568V12.7037H6.59376V11.2884H8.12556V5.51052H11.8554C12.7378 5.51052 18.5821 5.32728 18.5821 12.1043C18.5821 18.9934 12.4716 18.4812 12.4716 18.4812H12.4715Z"
        fill="#C2A633"
      />
    </svg>
  );
}
